import { Theme, alpha } from '@mui/material/styles';

export const adminDataGridSx = (theme: Theme) => ({
  backgroundColor: theme.palette.sandTint.main,
  fontFamily: "'Public Sans', sans-serif",
  borderRadius: 2,
  '& .MuiDataGrid-main': { borderRadius: 2 },
  '& .MuiDataGrid-container--top': {
    backgroundColor: theme.palette.forest.main,
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.forest.main,
    color: theme.palette.sand.main,
    fontSize: 16,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    color: theme.palette.sand.main,
  },
  '& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton, & .MuiDataGrid-columnSeparator': {
    color: theme.palette.sandShade3.main,
  },
  '& .MuiDataGrid-sortButton': {
    color: theme.palette.sand.main,
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: alpha(theme.palette.sand.main, 0.14),
    },
  },
  '& .MuiDataGrid-iconButtonContainer': {
    visibility: 'visible',
    width: 'auto',
  },
  '& .MuiDataGrid-sortButton .MuiDataGrid-sortIcon': {
    color: theme.palette.sand.main,
  },
  '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
    opacity: 0.75,
  },
  '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon': {
    opacity: 1,
    color: theme.palette.desert.main,
  },
  '& .MuiDataGrid-cell': {
    fontSize: 12,
  },
  '& .MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row:nth-of-type(2n)': {
    backgroundColor: alpha(theme.palette.forestTint2.main, 0.12),
  },
  '& .editable-date-cell': {
    cursor: 'pointer',
  },
  '& .editable-date-cell.MuiDataGrid-cell--editing': {
    boxShadow: `inset 0 0 0 1px ${theme.palette.forest.main}`,
  },
  '& .editable-date-cell .edit-icon': {
    opacity: 0,
    color: theme.palette.desert.main,
    fontSize: 20,
    transition: 'opacity 120ms ease-in-out',
  },
  '& .editable-date-cell:hover .edit-icon': {
    opacity: 1,
  },
  '& .editable-date-cell.MuiDataGrid-cell:focus-within': {
    boxShadow: `inset 0 0 0 1px ${theme.palette.forest.main}`,
  },
});
